<template>
  <form id="form-card" class="form px-i" @submit="submitForm($event)">
    <div class="form-wrapper container-fluid">
      <div class="card form-card">
        <div class="form-card-header px-i">
          <div class="form-card-header-title">
            <h2 class="form-card-header-title-text">
              {{ userMobileNumber.mobile_number }}
            </h2>
          </div>
          <div class="form-card-header-end">
            <div v-if="userMobileNumber.verified" class="form-card-header-end-pill">
              <div class="status-indicator status-green">
                {{ $t('user.verified') }}
              </div>
            </div>
            <div v-else class="form-card-header-end-pill">
              <div class="status-indicator status-red">
                {{ $t('user.notVerified') }}
              </div>
            </div>
          </div>
        </div>
        <div class="card-body form-card-body px-i">
          <TextInput
            v-model="editableMobileNumber"
            name="user_mobile_number[mobile_number]"
            type="tel"
            :custom-label="$t('common.mobile')"
            required
          />
          <div v-if="!userMobileNumber.verified">
            <TextInput
              v-model="userMobileNumber.verification_code"
              name="user_mobile_number[verification_code]"
              custom-label="Verification Code" />
            <div class="form-card-body-verification">
              <button type="button" class="btn btn-secondary ihjoz-button ihjoz-button mr-2" @click="saveChanges">
                {{ $t('common.save') }}
              </button>
              <button type="submit" class="btn btn-secondary ihjoz-button ihjoz-button mr-2">
                {{ $t('user.verifyMobile') }}
              </button>
              <button type="button" class="btn btn-secondary ihjoz-button" @click="clickResendCode($event)">
                {{ $t('user.resendCode') }}
              </button>
            </div>
          </div>
          <div v-else>
            <div class="form-card-body-verification">
              <button type="button" class="btn btn-secondary ihjoz-button ihjoz-button mr-2" @click="saveChanges">
                {{ $t('common.save') }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="card form-destroy px-i">
        <h3 class="form-destroy-title">
          {{ $t('user.deleteMobile') }}
        </h3>
        <p class="form-destroy-disclaimer">
          {{ $t('user.deleteMobileText') }}
        </p>
        <div class="form-destroy-controls">
          <div class="form-destroy-controls-checkbox custom-checkbox">
            <input id="destroy-confirm" v-model="checked" :disabled="allowDeletion()" class="custom-checkbox-input" type="checkbox">
            <label for="destroy-confirm" class="custom-checkbox-label">
              <span v-if="allowDeletion()" class="custom-checkbox-label-text">
                {{ $t('user.toDeleteMobileText') }}
              </span>
              <span v-else class="custom-checkbox-label-text">
                {{ $t('user.confirmDeleteMobileText') }}
              </span>
            </label>
          </div>
          <button type="button" :disabled="!checked" class="btn btn-danger ihjoz-button" @click="clickDestroy($event)">
            {{ $t('user.deleteMobileButton') }}
          </button>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
import TextInput from "../../../shared/components/UI/TextInput.vue";
import NotificationsMixin from "@shared/Mixins/NotificationsMixin";

export default {
  name: 'EditUserMobileNumberForm',

  components: {
    TextInput
  },

  mixins: [NotificationsMixin],

  props: ['userMobileNumber', 'userMobileNumbersCount'],

  data: function () {
    return {
      checked: false,
      editableMobileNumber: this.userMobileNumber.mobile_number
    };
  },

  methods: {
    allowDeletion () {
      return (this.userMobileNumber.primary || this.userMobileNumbersCount === 1);
    },

    submitForm (e) {
      this.$emit('formSubmit', e);
      this.saveChanges();
    },

    clickDestroy (e) {
      this.$emit('clickDestroy', e);
    },

    clickResendCode (e) {
      this.$emit('clickResendCode', e);
    },

    async saveChanges() {
      try {
        const response = await fetch(`/api/v4/users/${this.userMobileNumber.user_id}/user_mobile_numbers/${this.userMobileNumber.id}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ user_mobile_number: { mobile_number: this.editableMobileNumber } })
        });

        const data = await response.json();

        if (data.success) {
          this.notifySuccess(data.successMessage);
          this.$emit('updateUserMobileNumber', { mobile_number: this.editableMobileNumber });
          this.$router.push({ name: 'Edit User', params: { id: this.userMobileNumber.user_id } });
        } else {
          this.notifyError(data.errorMessages.join(', '));
        }
      } catch (error) {
        this.notifyError(error);
      }
    }
  }
};
</script>
